<div bsModal #mySettingsModal="bs-modal" (onShown)="onShown()" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true" [config]="{backdrop: 'static'}">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <form *ngIf="active" #mySettingsModalForm="ngForm" (ngSubmit)="save()">
                <div class="modal-header">
                    <h5 class="modal-title">
                        <span><span translation="MySettings" source=""></span></span>
                    </h5>
                    <button type="button" class="close" [attr.aria-label]="l('Close')" (click)="close()">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body" *ngIf="user">
                    <tabset>
                        <tab heading="{{'Profile' | localize}}">
                            <div class="form-group">
                                <label for="Name"><span translation="Name" source=""></span> *</label>
                                <input id="Name" #nameInput="ngModel" class="form-control" type="text" name="Name" [(ngModel)]="user.name" required maxlength="32">
                                <validation-messages [formCtrl]="nameInput"></validation-messages>
                            </div>

                            <div class="form-group">
                                <label for="Surname"><span translation="Surname" source=""></span> *</label>
                                <input id="Surname" #surnameInput="ngModel" type="text" name="Surname" class="form-control" [(ngModel)]="user.surname" required maxlength="32">
                                <validation-messages [formCtrl]="surnameInput"></validation-messages>
                            </div>

                            <div class="form-group">
                                <label for="EmailAddress"><span translation="EmailAddress" source=""></span> *</label>
                                <input id="EmailAddress" #emailAddressInput="ngModel" type="email" name="EmailAddress" class="form-control" [(ngModel)]="user.emailAddress" required email maxlength="256">
                                <validation-messages [formCtrl]="emailAddressInput"></validation-messages>
                            </div>
                            <div *ngIf="smsEnabled">
                                <div class="form-group">
                                    <label><span translation="PhoneNumber" source=""></span></label>
                                    <div class="input-group">
                                        <input type="text" name="PhoneNumber" class="form-control" [(ngModel)]="user.phoneNumber" maxlength="24">

                                        <span id="SpanSmsVerificationUnverified" class="input-group-btn">
                                            <button id="btnSmsVerification" (click)="smsVerify()" [disabled]="isPhoneNumberConfirmed && savedPhoneNumber == user.phoneNumber" class="btn btn-primary" type="button" tooltip="{{'YourPhoneNumberIsNotVerified' | localize}}">
                                                <i class="fa fa-exclamation-triangle"></i><span translation="Verify" source=""></span>
                                            </button>
                                        </span>

                                        <div *ngIf="isPhoneNumberConfirmed && savedPhoneNumber == user.phoneNumber" class="input-group-append" id="SpanSmsVerificationVerified">
                                            <span class="input-group-text" tooltip="{{'YourPhoneNumberIsVerified' | localize}}">
                                                <i class="la la-check kt-font-success" [attr.aria-label]="l('Verified')"></i>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="UserName"><span translation="UserName" source=""></span> *</label>
                                <input id="UserName" #userNameInput="ngModel" type="text" [disabled]="!canChangeUserName" class="form-control" [(ngModel)]="user.userName" name="UserName" required maxlength="32">
                                <span class="form-text text-muted" *ngIf="!canChangeUserName"><span translation="CanNotChangeAdminUserName" source=""></span></span>
                                <validation-messages [formCtrl]="userNameInput"></validation-messages>
                            </div>

                            <div class="form-group" *ngIf="showTimezoneSelection">
                                <label for="timezone"><span translation="Timezone" source=""></span></label>
                                <timezone-combo id="timezone" name="Timezone" [(ngModel)]="user.timezone" defaultTimezoneScope="{{defaultTimezoneScope}}"></timezone-combo>
                            </div>

                            <div class="form-group">
                                <label for="InterfaceLanguage"><span translation="InterfaceLanguage"></span></label>
                                <select id="InterfaceLanguage" name="InterfaceLanguage"
                                        class="form-control"
                                        [(ngModel)]="currentLanguage.name">
                                    <option *ngFor="let l of languages"
                                            [ngValue]="l.name"
                                            [label]="l.displayName"></option>
                                </select>
                            </div>
                        </tab>
                        <tab *ngIf="!isMultiTenancyEnabled || isTwoFactorLoginEnabledForApplication" heading="{{'TwoFactorLogin' | localize}}">
                            <div>
                                <h4>
                                    Authenticator
                                </h4>

                                <div [hidden]="!isGoogleAuthenticatorEnabled">
                                    <div>
                                        <span translation="ScanQrCodeWithYourMobileApp" source=""></span>
                                    </div>
                                    <div class="text-center m-4">
                                        <img [src]="user.qrCodeSetupImageUrl" height="300" />
                                    </div>
                                    <small>
                                        <span translation="GoogleAuthenticatorReferrerLink" source=""></span>: <a href="https://support.google.com/accounts/answer/1066447" target="_blank" rel="noopener noreferrer">Google Authenticator</a>
                                    </small>
                                </div>

                                <div [hidden]="isGoogleAuthenticatorEnabled">
                                    <button type="button" class="btn btn-success" (click)="updateQrCodeSetupImageUrl()"><span translation="Enable" source=""></span></button>
                                </div>

                                <div [hidden]="!isGoogleAuthenticatorEnabled">
                                    <button type="button" class="btn btn-danger" (click)="disableGoogleAuthenticator()"><span translation="Disable" source=""></span></button>
                                </div>
                            </div>
                        </tab>

                        <tab *ngIf="BasePermissionDefinition.User.ProfileManagement._ | permission" heading="{{'Axilla.Management.User.PersonalInformation' | localize}}">
                            <form #billingInformation="ngForm" role="form" novalidate class="form-validation">
                                <billingInformation
                                    [editUsersProfile]="BasePermissionDefinition.User.ProfileManagement._ | permission"
                                    [editUsersProfileVisitor]="BasePermissionDefinition.User.ProfileManagement.Visitor | permission"
                                    [editUsersProfileFinancial]="BasePermissionDefinition.User.ProfileManagement.Financial | permission"
                                    [editUsersProfileInvoice]="BasePermissionDefinition.User.ProfileManagement.Invoice | permission"
                                    [editUsersProfileDelivery]="BasePermissionDefinition.User.ProfileManagement.Delivery | permission"

                                    [billingInfoForm]="billingInfoForm"
                                    [billingInfoValidator]="billingInfoValidator"
                                    [billingInfo]="billInfo"></billingInformation>
                            </form>
                        </tab>

                    </tabset>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" (click)="close()" [disabled]="saving"><span translation="Cancel" source=""></span></button>
                    <button type="submit" class="btn btn-primary" [disabled]="!mySettingsModalForm.form.valid || saving"><i class="fa fa-save"></i> <span><span translation="Save" source=""></span></span></button>
                </div>
            </form>
        </div>
    </div>
</div>
<smsVerificationModal *ngIf="user" #smsVerificationModal (modalSave)="changePhoneNumberToVerified()" [newPhoneNumber]="user.phoneNumber"></smsVerificationModal>
